<template>
  <div
    class="attention__drop LKRoadmapsFeedAttentionDrop"
    @mouseenter="isActive = true"
    @mouseleave="isActive = false"
  >
    <img
      src="/images/vopros.svg"
      loading="lazy"
      alt=""
      class="title__atention-img"
    >

    <div
      :class="{ 'is-active': isActive }"
      class="text-xs-bold mod--attention-drop LKRoadmapsFeedAttentionDrop__desc"
      v-text="description"
    />
  </div>
</template>

<script>


export default {
  name: 'LKRoadmapsFeedAttentionDrop',
  props: {
    description: {
      type: String,
      required: true,
    },
  },
  data: () => ({
    isActive: false,
  }),
}
</script>

<style lang="scss">

div.LKRoadmapsFeedAttentionDrop {
  display: inline-block;
  margin-right: 8px !important; // TODO: Fix latter

  & &__desc {
    opacity: 0;
    transition: all 0.2s;

    &.is-active {
      display: block !important;
      opacity: 1;
    }
  }
}
</style>
